import React, {useRef} from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {Link} from "react-router-dom";
import styles from "./EventTypeTile.scss";

export default function EventTypeTile(props) {

    const renderLink = () => {
        if (props.event.link) {
            return (
                <a
                    className={"btn buttonNoBorder buttonNoBg small"}
                    href={props.event.link}
                    target="_blank"
                    ref={sessionLink}
                >Learn More ></a>
            );
        }

        return (
            <Link
                to={`/${props.event.eventType.slug}/`}
                className={"btn buttonNoBorder buttonNoBg small"}
                ref={sessionLink}
            >
                Learn More >
            </Link>
        )
    }

    const sessionLink = useRef();

    const handleClick = () => {
        sessionLink.current.click();
    }

    return (
        <div className={styles.root} onClick={handleClick}>
            <div
                className={styles.mainImage}
                style={{
                    backgroundImage: `url(${props.event.image})`,
                    borderBottom: `4px solid ${props.event.eventType.color}`
                }}
            >
                <div className={styles.sessionLogo}>
                    <img src={props.event.logo} alt={`${props.event.title} session logo`} />
                </div>
            </div>
            <div className={styles.infoBox}>
                <div className={styles.info}>
                    <h3>{props.event.title}</h3>
                    <p>{props.event.description}</p>
                </div>
                <div className={styles.eventLink}>
                    {renderLink()}
                </div>
            </div>
        </div>
    )

}

EventTypeTile.propTypes = {
    event: PropTypes.object.isRequired,
}